import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _Symbol$iterator;
var _dec, _class, _descriptor, _descriptor2;
import { computed, makeObservable, obx, action } from '@alilc/lowcode-editor-core';
import { IPublicEnumTransformStage } from '@alilc/lowcode-types';
import { uniqueId, compatStage } from '@alilc/lowcode-utils';
import { Prop, UNSET } from './prop';

// import { TransformStage } from '../transform-stage';

export var EXTRA_KEY_PREFIX = '___';
export function getConvertedExtraKey(key) {
  if (!key) {
    return '';
  }
  var _key = key;
  if (key.indexOf('.') > 0) {
    _key = key.split('.')[0];
  }
  return EXTRA_KEY_PREFIX + _key + EXTRA_KEY_PREFIX + key.slice(_key.length);
}
export function getOriginalExtraKey(key) {
  return key.replace(new RegExp("" + EXTRA_KEY_PREFIX, 'g'), '');
}
export var Props = (_dec = obx.shallow, (_class = (_Symbol$iterator = Symbol.iterator, /*#__PURE__*/function () {
  function Props(owner, value, extras) {
    var _this = this;
    this.id = uniqueId('props');
    _initializerDefineProperty(this, "items", _descriptor, this);
    this.path = [];
    this.owner = void 0;
    _initializerDefineProperty(this, "type", _descriptor2, this);
    this.purged = false;
    makeObservable(this);
    this.owner = owner;
    if (Array.isArray(value)) {
      this.type = 'list';
      this.items = value.map(function (item, idx) {
        return new Prop(_this, item.value, item.name || idx, item.spread);
      });
    } else if (value != null) {
      this.items = Object.keys(value).map(function (key) {
        return new Prop(_this, value[key], key, false);
      });
    }
    if (extras) {
      Object.keys(extras).forEach(function (key) {
        _this.items.push(new Prop(_this, extras[key], getConvertedExtraKey(key)));
      });
    }
  }
  var _proto = Props.prototype;
  _proto["import"] = function _import(value, extras) {
    var _this2 = this;
    var originItems = this.items;
    if (Array.isArray(value)) {
      this.type = 'list';
      this.items = value.map(function (item, idx) {
        return new Prop(_this2, item.value, item.name || idx, item.spread);
      });
    } else if (value != null) {
      this.type = 'map';
      this.items = Object.keys(value).map(function (key) {
        return new Prop(_this2, value[key], key);
      });
    } else {
      this.type = 'map';
      this.items = [];
    }
    if (extras) {
      Object.keys(extras).forEach(function (key) {
        _this2.items.push(new Prop(_this2, extras[key], getConvertedExtraKey(key)));
      });
    }
    originItems.forEach(function (item) {
      return item.purge();
    });
  };
  _proto.merge = function merge(value, extras) {
    var _this3 = this;
    Object.keys(value).forEach(function (key) {
      _this3.query(key, true).setValue(value[key]);
      _this3.query(key, true).setupItems();
    });
    if (extras) {
      Object.keys(extras).forEach(function (key) {
        _this3.query(getConvertedExtraKey(key), true).setValue(extras[key]);
        _this3.query(getConvertedExtraKey(key), true).setupItems();
      });
    }
  };
  _proto["export"] = function _export(stage) {
    if (stage === void 0) {
      stage = IPublicEnumTransformStage.Save;
    }
    stage = compatStage(stage);
    if (this.items.length < 1) {
      return {};
    }
    var allProps = {};
    var props = {};
    var extras = {};
    if (this.type === 'list') {
      props = [];
      this.items.forEach(function (item) {
        var value = item["export"](stage);
        var name = item.key;
        if (name && typeof name === 'string' && name.startsWith(EXTRA_KEY_PREFIX)) {
          name = getOriginalExtraKey(name);
          extras[name] = value;
        } else {
          props.push({
            spread: item.spread,
            name: name,
            value: value
          });
        }
      });
    } else {
      this.items.forEach(function (item) {
        var name = item.key;
        if (name == null || item.isUnset() || item.isVirtual()) return;
        var value = item["export"](stage);
        if (value != null) {
          allProps[name] = value;
        }
      });
      // compatible vision
      var transformedProps = this.transformToStatic(allProps);
      Object.keys(transformedProps).forEach(function (name) {
        var value = transformedProps[name];
        if (typeof name === 'string' && name.startsWith(EXTRA_KEY_PREFIX)) {
          name = getOriginalExtraKey(name);
          extras[name] = value;
        } else {
          props[name] = value;
        }
      });
    }
    return {
      props: props,
      extras: extras
    };
  }

  /**
   * @deprecated
   */
  /* istanbul ignore next */;
  _proto.transformToStatic = function transformToStatic(props) {
    var _this$owner$component, _this$owner$component2, _this$owner$component3;
    var transducers = (_this$owner$component = this.owner.componentMeta) === null || _this$owner$component === void 0 ? void 0 : (_this$owner$component2 = _this$owner$component.prototype) === null || _this$owner$component2 === void 0 ? void 0 : (_this$owner$component3 = _this$owner$component2.options) === null || _this$owner$component3 === void 0 ? void 0 : _this$owner$component3.transducers;
    if (!transducers) {
      return props;
    }
    if (!Array.isArray(transducers)) {
      transducers = [transducers];
    }
    props = transducers.reduce(function (xprops, transducer) {
      if (transducer && typeof transducer.toStatic === 'function') {
        return transducer.toStatic(xprops);
      }
      return xprops;
    }, props);
    return props;
  }

  /**
   * 根据 path 路径查询属性
   *
   * @param createIfNone 当没有的时候，是否创建一个
   */;
  _proto.query = function query(path, createIfNone) {
    if (createIfNone === void 0) {
      createIfNone = true;
    }
    return this.get(path, createIfNone);
  }

  /**
   * 获取某个属性，如果不存在，临时获取一个待写入
   * @param createIfNone 当没有的时候，是否创建一个
   */;
  _proto.get = function get(path, createIfNone) {
    if (createIfNone === void 0) {
      createIfNone = false;
    }
    var entry = path;
    var nest = '';
    var i = path.indexOf('.');
    if (i > 0) {
      nest = path.slice(i + 1);
      if (nest) {
        entry = path.slice(0, i);
      }
    }
    var prop = this.maps.get(entry);
    if (!prop && createIfNone) {
      prop = new Prop(this, UNSET, entry);
      this.items.push(prop);
    }
    if (prop) {
      return nest ? prop.get(nest, createIfNone) : prop;
    }
    return null;
  }

  /**
   * 删除项
   */;
  _proto["delete"] = function _delete(prop) {
    var i = this.items.indexOf(prop);
    if (i > -1) {
      this.items.splice(i, 1);
      prop.purge();
    }
  }

  /**
   * 删除 key
   */;
  _proto.deleteKey = function deleteKey(key) {
    var _this4 = this;
    this.items = this.items.filter(function (item, i) {
      if (item.key === key) {
        item.purge();
        _this4.items.splice(i, 1);
        return false;
      }
      return true;
    });
  }

  /**
   * 添加值
   */;
  _proto.add = function add(value, key, spread, options) {
    if (spread === void 0) {
      spread = false;
    }
    if (options === void 0) {
      options = {};
    }
    var prop = new Prop(this, value, key, spread, options);
    this.items.push(prop);
    return prop;
  }

  /**
   * 是否存在 key
   */;
  _proto.has = function has(key) {
    return this.maps.has(key);
  }

  /**
   * 迭代器
   */;
  _proto[_Symbol$iterator] = function () {
    var index = 0;
    var items = this.items;
    var length = items.length || 0;
    return {
      next: function next() {
        if (index < length) {
          return {
            value: items[index++],
            done: false
          };
        }
        return {
          value: undefined,
          done: true
        };
      }
    };
  }

  /**
   * 遍历
   */;
  _proto.forEach = function forEach(fn) {
    this.items.forEach(function (item) {
      return fn(item, item.key);
    });
  }

  /**
   * 遍历
   */;
  _proto.map = function map(fn) {
    return this.items.map(function (item) {
      return fn(item, item.key);
    });
  };
  _proto.filter = function filter(fn) {
    return this.items.filter(function (item) {
      return fn(item, item.key);
    });
  }

  /**
   * 回收销毁
   */;
  _proto.purge = function purge() {
    if (this.purged) {
      return;
    }
    this.purged = true;
    this.items.forEach(function (item) {
      return item.purge();
    });
  }

  /**
   * 获取某个属性, 如果不存在，临时获取一个待写入
   * @param createIfNone 当没有的时候，是否创建一个
   */;
  _proto.getProp = function getProp(path, createIfNone) {
    if (createIfNone === void 0) {
      createIfNone = true;
    }
    return this.query(path, createIfNone) || null;
  }

  /**
   * 获取单个属性值
   */;
  _proto.getPropValue = function getPropValue(path) {
    var _this$getProp;
    return (_this$getProp = this.getProp(path, false)) === null || _this$getProp === void 0 ? void 0 : _this$getProp.value;
  }

  /**
   * 设置单个属性值
   */;
  _proto.setPropValue = function setPropValue(path, value) {
    this.getProp(path, true).setValue(value);
  }

  /**
   * 获取 props 对应的 node
   */;
  _proto.getNode = function getNode() {
    return this.owner;
  }

  /**
   * @deprecated
   * 获取 props 对应的 node
   */;
  _proto.toData = function toData() {
    var _this$export;
    return (_this$export = this["export"]()) === null || _this$export === void 0 ? void 0 : _this$export.props;
  };
  _createClass(Props, [{
    key: "maps",
    get: function get() {
      var maps = new Map();
      if (this.items.length > 0) {
        this.items.forEach(function (prop) {
          if (prop.key) {
            maps.set(prop.key, prop);
          }
        });
      }
      return maps;
    }
  }, {
    key: "props",
    get: function get() {
      return this;
    }
  }, {
    key: "size",
    get:
    /**
     * 元素个数
     */
    function get() {
      return this.items.length;
    }
  }]);
  return Props;
}()), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "items", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "maps", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "size", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "size"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "type", [obx], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'map';
  }
}), _applyDecoratedDescriptor(_class.prototype, "import", [action], Object.getOwnPropertyDescriptor(_class.prototype, "import"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "merge", [action], Object.getOwnPropertyDescriptor(_class.prototype, "merge"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "query", [action], Object.getOwnPropertyDescriptor(_class.prototype, "query"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "get", [action], Object.getOwnPropertyDescriptor(_class.prototype, "get"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "delete", [action], Object.getOwnPropertyDescriptor(_class.prototype, "delete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteKey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "add", [action], Object.getOwnPropertyDescriptor(_class.prototype, "add"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forEach", [action], Object.getOwnPropertyDescriptor(_class.prototype, "forEach"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "map", [action], Object.getOwnPropertyDescriptor(_class.prototype, "map"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "filter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "purge", [action], Object.getOwnPropertyDescriptor(_class.prototype, "purge"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getProp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getProp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getPropValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getPropValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPropValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPropValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toData"), _class.prototype)), _class));